import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated()) {
            navigate("/login"); // Redirect to login if not authenticated
        }
    }, [navigate]);

    return isAuthenticated() ? children : null; // Render children only if authenticated
};

export default ProtectedRoute;
